import axios from "axios";
import { APP_URL, config } from "./serviceConstants";
import { getParams } from "../utlis/helpers";
import store from "../state/store";
import { setAPILoader, setErrorDisplay } from "../state/actions/globalAction";
import { getCurrentLocale, pageLocale } from "../utlis/locale";
import { postWebViewMessage } from "../utlis/webViewBridge";
const { errorCode } = pageLocale("common");
const MMT_SESSION_KEY = "mmtSession";

const getLiveToken = () => {
  const { accessToken } = getParams();
  if (accessToken) return accessToken;
  try {
    return (
      JSON.parse(
        sessionStorage.getItem(MMT_SESSION_KEY) ||
          localStorage.getItem(MMT_SESSION_KEY) ||
          "null",
      )?.accessToken || ""
    );
  } catch {
    return "";
  }
};

const api = axios.create({ baseURL: APP_URL });

api.interceptors.request.use(
  (cfg) => {
    const tok = getLiveToken();
    if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
    // Active app language (already honors ?locale= at boot, then the
    // switcher / device language) — not just the URL param.
    cfg.headers["Accept-Language"] = getCurrentLocale();
    return cfg;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      const tok = getLiveToken();
      const { locale: loc } = getParams();
      store.dispatch(setErrorDisplay(errorCode));
      store.dispatch(setAPILoader(true));
      logoOut({ globalSignOut: false, token: tok })
        .then(() => {
          localStorage.removeItem(MMT_SESSION_KEY);
          localStorage.removeItem("lastVisitedUrl");
          sessionStorage.removeItem(MMT_SESSION_KEY);
          sessionStorage.removeItem("userList");
          sessionStorage.removeItem("userIndex");
          sessionStorage.removeItem("testMModule");
          sessionStorage.removeItem("staffDetails");
          // Token expired: notify the WebView shell (if any) and always ask
          // the user to log in again on the web login screen.
          postWebViewMessage("TOKEN_INVALID");
          window.location.href = `/login?locale=${loc || "en"}`;
          store.dispatch(setAPILoader(false));
        })
        .catch(() => {
          store.dispatch(setAPILoader(false));
        });
    } else {
      store.dispatch(setErrorDisplay(error.response?.data?.message));
    }
    return Promise.reject(error);
  },
);

const { staffId } = getParams();
export const getLoggedUserInfo = async (id) => {
  const appURL = "/users/" + id;
  return api.get(appURL, config);
};

export const getUserList = async (page, limit, filterField, filter) => {
  let appURL = `v3/seniors?page=${page}&limit=${limit}`;
  if (filterField) appURL += `&filterField=${filterField}`;
  if (filter) appURL += `&filter=${filter}`;
  return api.get(appURL, config);
};

export const getCustomTheme = async () => {
  const { providerId, adminId, clientId } = getParams();
  const appURL =
    APP_URL +
    `app/theme?providerId=${providerId}&adminId=${adminId}&clientId=${clientId}`;
  return api.get(appURL, config);
};

export const getTimeline = async () => {
  // let params = "";
  // if (staffId) {
  //   params += "seniorId=" + staffId;
  // } else {
  //   params += "providerId=" + providerId;
  // }
  // const appURL = `v3/notification/all?${params}`;
  const appURL = `v5/notification/all?providerId=${staffId}`;
  return api.get(appURL, config);
};

export const getTestModule = async (uuid, Id) => {
  const appURL =
    "v3/seniors/" + uuid + "/modules?seniorId=" + Id + "&aaddnndd&status=1";
  return api.get(appURL, config);
};

export const getTestPersonInfo = async (uuid) => {
  const appURL = "v3/seniors/" + uuid;
  return api.get(appURL, config);
};

export const removeSenior = async (uuid) => {
  const appURL = "v2/seniors/" + uuid + `?isHardDelete=false`;
  return api.delete(appURL, config);
};

export const getHistoryList = async (uuid) => {
  const appURL = "seniors/" + uuid + "/history?moduleId=999";
  return api.get(appURL, config);
};

export const logoOut = async (request) => {
  const appURL = "logout";
  return api.post(appURL, request, config);
};

export const afterUploadFileSuccess = (seniorId, request) => {
  const appURL = "v3/seniors/" + seniorId + "/events";
  return api.post(appURL, request, config);
};

export const changeEmailInfo = (request, seniorId) => {
  const appURL = "/v3/seniors/" + seniorId;
  return api.put(appURL, request, config);
};

export const unreadTimelineCount = () => {
  const appURL = `v3/notification/unread?providerId=${staffId}`;
  return api.get(appURL, config);
};
